<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import watermark from '@/utils/sy-watermark.js';

export default {
  mounted() {
    watermark.init({
      watermark_txt: 'SRM-MALL' + ' ' + (this.$store.getters.userInfo.name || ''),
      watermark_width: 500
    });
  },
};
</script>

<script>
document.write(
  "<script type='text/javascript' async='async' id='browserScript' data='Chrome=74&IE=11&SystemName=SRM-MALL供应链协同平台' src='https://www.syounggroup.com/activity/browser-help/browser-help.js?t=" +
    Date.now() +
    "' ><\/script>",
);
// document.cookie = 'JSESSIONID=D67A7777ABD14542CD6085979C17529E';
// document.cookie = '_tk=Gtd3ruMl2Ji9bHwnruMyoJQgD0RC7kOvjyO_-d8AAEc';
// document.cookie = 'yjh.session.id=3c21eb6e440c4c2caa6f6b6d9a5cb46e';
</script>

<style lang="scss">
body {
  margin: 0 !important;
}
#app {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB',
    'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  height: 100vh;
}
</style>
